module.exports = __webpack_public_path__ + "img/03.e2640fa7.png";